<template>
  <v-menu offset-y

        v-model="menu"
        :close-on-content-click="false"
        :nudge-width="400"
        >
        <template v-slot:activator="{ on: menu }">
            <v-tooltip top>
          <template v-slot:activator="{ on: tooltip }">
      <v-btn dark fab small color="success" v-on="{...menu, ...tooltip}"><v-icon dark>$add</v-icon></v-btn>
      </template>
      <span>{{$t('campaigns.segment.tag.add')}}</span>
            </v-tooltip>
      </template>
        <v-card>
            <v-card-title>{{ $t('campaigns.segment.tag.add')}}</v-card-title>
            <v-card-text>
            <v-text-field dense v-model="newTagName" :label="$t('common.name')" />
            </v-card-text>
            <v-card-actions>
                <v-btn color="success" :disabled="!newTagName || newTagName.length==0" text @click="$emit('create', newTagName);newTagName=null" :loading="creating">
                    <v-icon left>$add</v-icon>{{ $t('form.create')}}</v-btn>
                <v-btn text @click="$emit('input', false)"><v-icon left>$close</v-icon>{{ $t('form.cancel')}}</v-btn>
            </v-card-actions>
        </v-card>
     </v-menu>
</template>

<script>
export default {
    name: 'TagCreate',
    props: {
        value: Boolean,
        creating: Boolean
    },
    data() {
        return {
            newTagName: null
        }
    },
    computed: {
        menu: {
            get() {
                return this.value;
            },
            set(val) {
                this.$emit('input', val)
            }
        }
    }
}
</script>

<style>

</style>